module.exports = __webpack_public_path__ + "static/screen-shot-2018-09-14-at-10.42.54-569edcd134984de06b63153cdfbdba13.png";